import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M38.265 38.54c1.117-1.125 1.682-1.761 2.245-2.546l.134-.157.084-.097c.56-.648.686-.887.714-1.295.05-.697-.3-1.303-1.405-2.329-.739-.685-1.633-1.276-2.761-1.829a57 57 0 0 0-.746-.363c-.819-.39-1.406-.61-1.965-.733-.92-.205-1.624-.103-2.193.302-.27.192-.478.394-.921.898l-.122.139c-.153.174-.253.284-.355.39-.74.773-1.472 1.354-2.253 1.77-3.626 1.932-8.546 1.163-11.662-1.809-1.786-1.874-2.834-4.572-2.772-7.16.05-2.088.742-4.125 1.957-5.737.33-.437.633-.773 1.389-1.543.21-.214.21-.214.342-.351.555-.577.792-1.133.787-1.83-.005-.728-.163-1.287-.743-2.622l-.069-.159-.067-.155c-.534-1.24-.95-2.011-1.46-2.702-.75-1.017-1.448-1.638-2.165-1.937-.356-.148-.703-.17-1.016-.073-.295.093-.479.212-1.016.68-.145.126-.145.126-.277.235-2.412 1.848-3.755 3.351-4.54 5.119-1.3 2.93-1.11 6.522.506 10.524 1.434 3.548 3.84 6.999 6.963 10a32 32 0 0 0 5.778 4.732c3.038 1.954 6.07 3.133 8.956 3.462 2.37.269 4.59-.113 6.426-1.116.779-.424 1.509-.985 2.227-1.708m-1.244 3.51c-2.223 1.213-4.867 1.669-7.64 1.353-3.223-.367-6.547-1.66-9.835-3.775-2.269-1.459-4.366-3.175-6.12-5.007-3.294-3.166-5.868-6.856-7.413-10.682-1.81-4.48-2.029-8.633-.479-12.126.945-2.13 2.506-3.877 5.137-5.891.072-.06.072-.06.207-.178.733-.638 1.13-.896 1.751-1.09.787-.247 1.628-.193 2.417.136 1.11.462 2.075 1.322 3.028 2.613.617.835 1.102 1.737 1.693 3.107l.066.152.068.157c.68 1.567.906 2.364.913 3.425.01 1.252-.445 2.317-1.36 3.269l-.356.365c-.698.712-.952.993-1.215 1.342-.954 1.265-1.504 2.886-1.544 4.55-.05 2.043.794 4.214 2.17 5.66 2.452 2.337 6.416 2.957 9.247 1.448.574-.306 1.138-.752 1.735-1.377.08-.082.162-.173.297-.327l.121-.137c.54-.614.848-.914 1.274-1.217 1.08-.768 2.374-.956 3.827-.633.731.162 1.455.433 2.401.883.19.09.362.174.77.375 1.296.635 2.356 1.336 3.251 2.167 1.517 1.407 2.162 2.523 2.057 3.978-.065.93-.385 1.54-1.209 2.492l-.08.094c-.66.903-1.29 1.614-2.479 2.81-.853.86-1.74 1.541-2.7 2.064",
      clipRule: "evenodd"
    }
  )
);
var SvgCallOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CallOutlined_default = SvgCallOutlined;

export { CallOutlined_default as default };
